import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetPropertyDealController = async (propertyId) => {
  /**
   * input: null
   * output: property deal document / collection
   * description: get property deal / get documents
   */

  try {
    const dealsCollection = collection(db, "deals");
    const q = query(dealsCollection, where("property.id", "==", propertyId));
    const dealSnapshot = await getDocs(q);
    const dealsData = [];
    dealSnapshot.forEach((deal) =>
      dealsData.push({ id: deal.id, ...deal.data() })
    );
    return dealsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetPropertyDealController;
